import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uiDux from 'src/redux/ui';
import appDux from 'src/redux/app/';
import HvSvg from 'src/components/HvSvg';
import MaterialButton from './MaterialButton';

import {
  MaterialButtonsContainer,
  CategoryContainer,
  CategoryHeader,
  MaterialCount,
  CategoryName,
} from './styled';

const mapStateToProps = (state) => ({
  modelMaterialsByCategory: appDux.selectors.getModelMaterialsByCategory(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleDesignCategoryClick: uiDux.actions.handleDesignCategoryClick,
      handleDesignMaterialClick: uiDux.actions.handleDesignMaterialClick,
    },
    dispatch,
  );

export class AllCategories extends PureComponent {
  static propTypes = {
    handleDesignCategoryClick: PropTypes.func.isRequired,
    handleDesignMaterialClick: PropTypes.func.isRequired,
    modelMaterialsByCategory: PropTypes.object.isRequired,
  };

  render() {
    const {
      handleDesignCategoryClick,
      handleDesignMaterialClick,
      modelMaterialsByCategory,
    } = this.props;

    return modelMaterialsByCategory.map(([categoryName, modelMaterials]) => (
      <CategoryContainer data-selenium="materialCategory" key={categoryName}>
        <CategoryHeader
          role="button"
          onClick={() => handleDesignCategoryClick(categoryName)}
        >
          <CategoryName data-selenium="categoryNameText">
            {categoryName}
          </CategoryName>
          <MaterialCount>
            {Object.keys(modelMaterials).length}
            <HvSvg
              src={require('src/assets/images/right-arrow.svg')}
              disabled={false}
            />
          </MaterialCount>
        </CategoryHeader>
        <MaterialButtonsContainer>
          {Object.values(modelMaterials).map((material) => (
            <MaterialButton
              key={material.id}
              {...material}
              handleClick={handleDesignMaterialClick}
            />
          ))}
        </MaterialButtonsContainer>
      </CategoryContainer>
    ));
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllCategories);
